import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Stack,
} from "@mui/material";
import { batchDetailsForExectivePG } from "../../constants/External";
import TalkToOurConsultantPopup from "./Popup/TalkToOurConsultantPopupv2";
import { DEVOPS_AND_AZURE, EXECUTIVE_PG_DEVOPS_PROGRAM, EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT } from "../../constants/AzureDevops";
import BroucherPopupv2 from "./Popup/BroucherPopupv2";

const AdmissionBanner = (props) => {
    const [ttocpopupOpen, setTtocPopupOpen] = useState(false);
    const [open, setOpen] = useState(false);

    const { isSmallScreen, course } = props;
    const [targetDate] = useState(() => {
        const date = new Date();

        // Tomorrow at 12:00 AM
        date.setDate(date.getDate() + 1);
        date.setHours(0, 0, 0, 0);

        return date;
    });

    const getTimeLeft = () => {
        const now = new Date();
        const difference = targetDate.getTime() - now.getTime();

        if (difference <= 0) {
            return {
                days: "00",
                hours: "00",
                minutes: "00",
                seconds: "00",
            };
        }

        return {
            days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, "0"),
            hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, "0"),
            minutes: String(Math.floor((difference / (1000 * 60)) % 60)).padStart(2, "0"),
            seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
        };
    };

    const [timeLeft, setTimeLeft] = useState(getTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(getTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formattedDate = targetDate.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    });

    return (
        <Box
            sx={{
                width: {
                    xs: "100%",
                    md: "80%",
                },
                mx: "auto",
                bgcolor: "#F8EFFF",
                py: 1.5,
                px: { xs: 2, md: 5 },
                fontFamily: "Poppins, sans-serif",
                color: "#222",
                borderRadius: 0,
                mt: 4,
                borderRadius: 4,
            }}
        >
            <Typography
                sx={{
                    fontSize: { xs: "1.2rem", md: "1.5rem" },
                    fontWeight: 700,
                    fontFamily: "Poppins, sans-serif",
                    color: '#8C00FF'
                }}
            >
                Live Online Classes Starting On {batchDetailsForExectivePG[1].slice(0, 11)}
            </Typography>

            <Typography
                sx={{
                    mt: 0.5,
                    fontSize: { xs: "12px", md: "16px" },
                    fontFamily: "Poppins, sans-serif",
                    color: "#666",
                }}
            >
                Admission Closes On
            </Typography>

            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mt={1}
                mb={2}
            >
                <Typography
                    sx={{
                        fontSize: { xs: "16px", md: "20px" },
                        fontWeight: 600,
                        fontFamily: "Poppins, sans-serif",
                    }}
                >
                    {formattedDate}
                </Typography>

                <Typography
                    sx={{
                        fontSize: "18px",
                        fontWeight: 600,
                        fontFamily: "Poppins, sans-serif",
                        fontVariantNumeric: "tabular-nums",
                        letterSpacing: 1,
                    }}
                >
                    <Stack direction="row" spacing={1}>
                        {[
                            { value: timeLeft.hours, label: "H" },
                            { value: timeLeft.minutes, label: "M" },
                            { value: timeLeft.seconds, label: "S" },
                        ].map((item, index) => (
                            <React.Fragment key={item.label}>
                                <Box
                                    sx={{
                                        bgcolor: "white",
                                        color: "#ff0f0f",
                                        px: 1.5,
                                        py: 1,
                                        borderRadius: 2,
                                        boxShadow: "0 4px 12px rgba(140,0,255,0.25)",
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={0.5}
                                        alignItems="baseline"
                                        justifyContent="center"
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: { xs: 18, md: 30 },
                                                fontWeight: 700,
                                                lineHeight: 1,
                                                fontVariantNumeric: "tabular-nums",
                                            }}
                                        >
                                            {item.value}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: 10,
                                                fontWeight: 600,
                                                opacity: 0.9,
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                    </Stack>
                                </Box>

                                {index < 2 && (
                                    <Typography
                                        sx={{
                                            fontSize: 22,
                                            fontWeight: 700,
                                            alignSelf: "center",
                                            color: "#8C00FF",
                                        }}
                                    >
                                        :
                                    </Typography>
                                )}
                            </React.Fragment>
                        ))}
                    </Stack>
                </Typography>
            </Stack>

            <Stack direction="row" spacing={1.5}>
                <Button
                    variant="contained"
                    fullWidth
                    sx={{
                        bgcolor: "#7B2CBF",
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 600,
                        fontSize: "13px",
                        py: 1,
                        borderRadius: 2,
                        textTransform: "none",
                        "&:hover": {
                            bgcolor: "#6A1FB0",
                        },
                    }}
                    onClick={() => setTtocPopupOpen(true)}
                >
                    Apply Now
                </Button>

                <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => setOpen(true)}
                    sx={{
                        borderColor: "#7B2CBF",
                        color: "#7B2CBF",
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 600,
                        fontSize: "13px",
                        py: 1,
                        borderRadius: 2,
                        textTransform: "none",
                        "&:hover": {
                            borderColor: "#7B2CBF",
                            bgcolor: "#F4E8FF",
                        },
                    }}
                >
                    Download Brochure
                </Button>
            </Stack>
            <TalkToOurConsultantPopup
                isSmallScreen={isSmallScreen}
                open={ttocpopupOpen}
                onClose={() => setTtocPopupOpen(false)}
            />
            {open &&
                <BroucherPopupv2 setOpen={setOpen} open={open} isSmallScreen={isSmallScreen} brochure={true} heading={(course === EXECUTIVE_PG_DEVOPS_PROGRAM || course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) ? EXECUTIVE_PG_DEVOPS_PROGRAM : DEVOPS_AND_AZURE} />
            }
        </Box>
    );
};

export default AdmissionBanner;